import {
  Card,
  CardHeader,
  Divider,
  CardContent,
  CardActions,
  Button,
  makeStyles
} from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone';
import { Controller, useForm } from 'react-hook-form';
import { ScaleLoader } from 'react-spinners';
import { Patient, Result } from 'src/generated/graphql';
import { useStoreResults } from 'src/utils/uploadToFirebaseStorage';
import { LinearProgressWithLabel } from '../LinearProgressWithLabel';

interface ResultsForm extends Result {
  files: File[];
}

const useStyles = makeStyles(_theme => ({
  previewChip: {
    minWidth: 160,
    maxWidth: 210
  },
  dropzone: {
    height: '50%',
    minHeight: 20
  }
}));

export const AddResultsDialog = (props: {
  appointment_id: string;
  patient: Patient;
}) => {
  const classes = useStyles();
  /* ------------------------------ Upload Hooks ------------------------------ */

  const { progress, uploadFiles, uploading } = useStoreResults();

  /* ------------------------------- Form Hooks ------------------------------- */

  const { control: resultsControl, handleSubmit } = useForm<ResultsForm>();
  const onSubmitResults = handleSubmit(data => {
    if (data.files) {
      uploadFiles(data.files, props.patient.id, props.appointment_id);
    }
  });
  return (
    <Card>
      <CardHeader title="Subir nuevos resultados" />
      <Divider />
      <CardContent>
        <Controller
          control={resultsControl}
          name="files"
          render={({ field }) => (
            <DropzoneArea
              {...field}
              filesLimit={4}
              acceptedFiles={['image/*', 'application/pdf']}
              dropzoneText="Arrastre archivos o haga click para seleccionar"
              getFileLimitExceedMessage={(value: number) =>
                `Número máximos de archivos excedido (${value})`
              }
              getFileAddedMessage={(fileName: string) =>
                `${fileName} añadido exitosamente`
              }
              getFileRemovedMessage={(fileName: string) =>
                `${fileName} removido exitosamente`
              }
              getDropRejectMessage={(rejectedFile: File) =>
                `${rejectedFile.name} rechazado`
              }
              showPreviews={true}
              showPreviewsInDropzone={false}
              useChipsForPreview
              previewGridProps={{
                container: {
                  spacing: 1,
                  direction: 'row'
                }
              }}
              previewChipProps={{
                classes: {
                  root: classes.previewChip
                }
              }}
              dropzoneClass={classes.dropzone}
              previewText="Archivos seleccionados"
              dropzoneProps={{
                maxSize: 10
              }}
            />
          )}
        />
        <LinearProgressWithLabel value={progress} />
      </CardContent>
      <CardActions>
        {uploading ? (
          <ScaleLoader />
        ) : (
          <Button
            size="medium"
            color="primary"
            variant="outlined"
            onClick={onSubmitResults}
          >
            Subir archivos
          </Button>
        )}
      </CardActions>
    </Card>
  );
};
